import React from 'react'
import { useTestContext } from './TestContext'

const NoteInputSection: React.FC = () => {
  const { 
    activeTab, 
    noteInput, 
    setNoteInput, 
    handleNotes, 
    isAdding,
  } = useTestContext()

  if (activeTab !== 'notes') {
    return null
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (noteInput.trim() && !isAdding) {
      handleNotes(e)
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      if (noteInput.trim() && !isAdding) {
        handleNotes(e as any)
      }
    }
  }

  return (
    <div
      className='border-top pt-4 pb-4 px-6'
      style={{ backgroundColor: 'white' }}
    >
      <form onSubmit={handleSubmit}>
        <div className='d-flex align-items-center'>
          <input
            type='text'
            className='form-control me-1'
            placeholder='Leave a note'
            name='notes'
            value={noteInput}
            onChange={(e) => setNoteInput(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          {isAdding ? (
            <button
              type='button'
              className='btn btn-sm fs-6'
              onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#148363')
              }
              onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#0E9F6E')
              }
              disabled
              style={{
                backgroundColor: '#0E9F6E',
                color: '#fff',
                width: '180px',
                height: '42px',
                borderRadius: '4px',
                marginLeft: '4px',
                transition: 'background-color 0.3s',
              }}
            >
              Adding... <span className='spinner-border spinner-border-sm align-middle m-2'></span>
            </button>
          ) : (
            <button
              type='submit'
              className='btn btn-sm fs-6'
              onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#148363')
              }
              onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#0E9F6E')
              }
              disabled={!noteInput.trim()}
              style={{
                backgroundColor: '#0E9F6E',
                color: '#fff',
                width: '120px',
                height: '42px',
                borderRadius: '4px',
                marginLeft: '4px',
                transition: 'background-color 0.3s',
              }}
            >
              Add Note
            </button>
          )}
        </div>
      </form>
    </div>
  )
}

export default NoteInputSection
